import "./App.css";
import { css } from "@emotion/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { MediaModal, MediaModalProps } from "./components/molecules";
import {
  HumburgerMenu,
  titles,
  Header,
  SNS,
  Abema,
  Introduction,
  Episode,
  Chart,
  Original,
  Special,
  Staff,
  Footer,
} from "./components/organisms";
import { useLayoutEffect, useMemo, useState } from "react";

const youtubeID = "B4411jVKCVs";

function Home() {
  const [youtubeId, setYoutubeId] = useState<MediaModalProps["id"]>(undefined);
  const [isHomeImgLoaded, setIsHomeImgLoaded] = useState(false);

  const youtubeModalProps: MediaModalProps = useMemo(
    () => ({
      type: "youtube",
      id: youtubeId,
      onClose: () => setYoutubeId(undefined),
      getMediaArgs: { max: 700 },
    }),
    [youtubeId],
  );

  useLayoutEffect(() => {
    setYoutubeId(youtubeID);
  }, []);
  return (
    <>
      <MediaModal {...youtubeModalProps} />
      <HumburgerMenu />
      <div id="top" css={topContainerStyle}>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/home.png"}
          css={homeImgStyle(isHomeImgLoaded)}
          alt="home-img"
          onLoad={() => setIsHomeImgLoaded(true)}
        />
      </div>
      <Header titles={titles} />
      <SNS />
      <Abema />
      <Introduction title={titles[0]} />
      <Episode title={titles[1]} />
      <Chart title={titles[2]} />
      <Original title={titles[3]} />
      <Special title={titles[4]} />
      <Staff />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App" css={appStyle}>
      <Router basename={process.env.REACT_APP_BASE_PATH}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

const primaryColor = "#D90012";
const spSize = 768;

const appStyle = css`
  min-height: 100vh;
  font-family: "Noto Sans JP", sans-serif;
  background-color: ${primaryColor};
  color: white;
`;

const topContainerStyle = css`
  width: 100%;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding-top: 20px;
  }
`;

const homeImgStyle = (isLoaded: boolean) => css`
  width: 90%;
  height: auto;
  opacity: ${isLoaded ? 1 : 0};
`;

export default App;
